import { render, staticRenderFns } from "./NewProjectWizard.vue?vue&type=template&id=1c9f09d7&"
import script from "./NewProjectWizard.vue?vue&type=script&lang=js&"
export * from "./NewProjectWizard.vue?vue&type=script&lang=js&"
import style0 from "./NewProjectWizard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports